import request from '@/utils/request'

export function getRedpackList(type) {
  return request({
    url: '/product/red-packet/my/redPacket/group/' + type,
    method: 'get',
  })
}

export function getRedpackCenter() {
  return request({
    url: '/product/red-packet/center/group',
    method: 'get',
  })
}
export function getRedpack(id) {
  return request({
    url: '/product/red-packet/claim/' + id,
    method: 'put',
  })
}
export function getStoreCommandRedpack(data) {
  return request({
    url: '/product/store-red-packet/claim-command',
    method: 'post',
    data,
  })
}
